import React from 'react';
import LayoutNavItem from '../../atoms/LayoutNavItem/LayoutNavItem';

const LayoutNav = ({ items }) => {
  const { pathname } = window.location;

  return (
    <div className='overflow-x-auto h-max rounded-lg bg-gray-3 p-[10px] md:w-max md:overflow-x-visible'>
      <div className='flex min-w-max md:flex-col'>
        {items
          .filter((item) => !item.hidden)
          .map((item, index) => (
            <LayoutNavItem
              key={index}
              title={item.title}
              href={item.href}
              isActive={pathname.startsWith(item.href)}
            />
          ))}
      </div>
    </div>
  );
};

export default LayoutNav;
